import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// project-imports
import useAuth from 'hooks/useAuth';
import { safeReturnTo } from 'utils/return-to';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //
//
// The login page is for people without a session. Someone who already has one goes back to where
// they were headed, or to the home page.

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  useEffect(() => {
    if (isLoggedIn) {
      navigate(safeReturnTo(returnTo), { replace: true });
    }
  }, [isLoggedIn, navigate, returnTo]);

  return isLoggedIn ? null : children;
};

export default GuestGuard;
